import React, { useState } from 'react';
import { findPath } from 'react-querybuilder';
import { IconButton } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';
import { levelsColors } from './constants';
import Select from '../../Select/Select';
import MenuItem from '../../MenuItem/MenuItem';
import { isOnlyMobile } from '../../../services/isMobile';

export default ({ options, value, level, handleOnChange, path, query }) => {
  const [isCollapsed, setCollapsed] = useState(false);

  const { combinator } = findPath(path.slice(0, -1), query);
  const levelColor = levelsColors[level % levelsColors.length];
  const offsetLineColor = levelsColors[(level + levelsColors.length - 1) % levelsColors.length];
  const levelControlsStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    color: '#fafafa',
    borderRadius: '4px',
    backgroundColor: `${levelColor}`,
  };

  let selectorNode = null;

  const handleCollapseButtonClick = () => {
    if (selectorNode) {
      if (isCollapsed) {
        selectorNode.parentNode.classList.remove('query-collapsed');
      } else {
        selectorNode.parentNode.classList.add('query-collapsed');
      }
    }
    setCollapsed(!isCollapsed);
  };

  const collapseButton = (
    <IconButton className={`query-builder-collapse-button ${isCollapsed ? 'collapsed' : ''}`} onClick={handleCollapseButtonClick}>
      <ArrowDropDown fontSize="small" />
    </IconButton>
  );

  return (
    <div className="query-builder-combinator-selector" ref={(node) => (selectorNode = node)}>
      {level > 0 && (
        <>
          <div className="query-builder-offset-line" style={{ borderColor: `${offsetLineColor}` }} />
          <div className="query-builder-combinator-indicator">{combinator}</div>
        </>
      )}
      <div style={levelControlsStyle} className="combinator-selector-container">
        <Select value={value} onChange={(event) => handleOnChange(event.target.value)}>
          {options.map(({ name, label }) => (
            <MenuItem key={name} value={name} title={label}>
              {label}
            </MenuItem>
          ))}
        </Select>
        <div className="query-builder-combinator-text">
          of the following are true:
          {isOnlyMobile ? collapseButton : ''}
        </div>
      </div>
    </div>
  );
};
